<template src="@/templates/account/twoFactorAuthentication.html"></template>

<script>
import Disclaimer from "@/components/disclaimer/Disclaimer";
import { validationMixin } from "vuelidate";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import LoginModel from "@/models/loginModel";
import { mapActions, mapGetters } from "vuex";
import { profileInterpreterMixin } from "@/mixins/profiles/interpreter";

export default {
  name: "TwoFactorAuthentication",
  data() {
    return {
      otp: "",
      errorMessage: "",
      successMessage: "",
      messageText: "",
      mobileLastDigit: localStorage.getItem("mobile_last_digit"),
      passCodeTimer: "",
      timer: null,
      disableResend: true,
    };
  },
  mixins: [validationMixin, profileInterpreterMixin],
  validations: {
    otp: {
      required,
      maxLength: maxLength(6),
      minLength: minLength(6),
    },
  },
  components: { Disclaimer },
  computed: {
    ...mapGetters(["isBookingsConfirmed", "getRouteName"]),
    title() {
      return "INTERPRETER LOGIN";
    },
  },
  watch: {
    $route: "fetchData",
    isBookingsConfirmed: {
      handler: function () {
        this.fetchInterpreterProfile;
      },
      deep: true,
    },
  },
  created: function () {
    let otp_token = localStorage.getItem("otp_token");
    if (!otp_token) {
      this.redirectToLogin();
    }

    let otp_delivery = localStorage.getItem("otp_delivery");
    if (otp_delivery == "SMS") {
      this.messageText =
        "Enter the One Time Passcode (OTP) that has been sent to your mobile phone number ending in" +
        this.mobileLastDigit +
        ". OTP will expire after 5 minutes.";
    } else if (otp_delivery == "Email") {
      this.messageText =
        "Enter the One Time Passcode (OTP) that has been sent to your email address " +
        localStorage.getItem("email") +
        ". OTP will expire after 5 minutes.";
    } else {
      this.messageText = "ERROR";
    }

    this.runTimer();
  },
  methods: {
    ...mapActions(["updateToken"]),
    redirectToLogin() {
      localStorage.removeItem("otp_token");
      this.$router.push({ path: "/login" });
    },
    runTimer() {
      this.disableResend = true;
      this.passCodeTimer = 60;
      this.timer = setInterval(this.checkTimer, 1000);
    },
    checkTimer() {
      if (this.passCodeTimer > 0) {
        this.disableResend = true;
        this.passCodeTimer = this.passCodeTimer - 1;
      } else {
        this.disableResend = false;
        clearInterval(this.timer);
      }
    },
    validateOTP() {
      this.errorMessage = null;
      this.successMessage = null;
      this.$v.$touch();
      console.log(this.$v);
      if (this.$v.$error) {
        return;
      }

      this.$vs.loading();

      this.loginModel = new LoginModel();
      this.loginModel
        .save({
          url: this.$apiAllGraduatesUrl + this.loginModel.getRoute("checkOTP"),
          headers: {
            bearer: localStorage.getItem("otp_token"),
          },
          data: {
            otp: this.otp,
          },
        })
        .then((res) => {
          this.$vs.loading.close();
          let invalidOTPMessage =
            "The One Time Passcode (OTP) you entered is not valid. Please try again.";
          let response = res.response.data;
          console.log(response);
          if (!response) {
            this.errorMessage = "No response";
            return;
          }

          if (response.error) {
            if (response.invalid_otp) {
              this.errorMessage = invalidOTPMessage;
              return;
            }

            if (response.otp_expired) {
              this.errorMessage =
                "The One Time Passcode (OTP) you entered has expired. Please send again.";
              return;
            }

            if (response.message == "Expired token") {
              this.redirectToLogin();
              return;
            }

            this.errorMessage = invalidOTPMessage;
            return;
          }

          if (!response.token) {
            this.errorMessage = invalidOTPMessage;
            return;
          }
          localStorage.setItem("jwt", response.token);
          localStorage.removeItem("otp_token");
          /**Update jwt in store*/
          this.updateToken(response.token);

          this.fetchInterpreterProfile;
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);

          this.createErrorLog({
            message:
              "Mobile Last Digit: " +
              localStorage.getItem("mobile_last_digit") +
              " " +
              JSON.stringify(error),
            file: "TwoFactorAuthentication.vue",
            process: "validateOTP",
            project: "interpreterv2.allgraduates.com.au",
          });

          this.errorMessage = "Internal error";
          debugger;
        });
    },
    resendOTP() {
      this.errorMessage = "";
      this.successMessage = "";
      this.otp = "";
      this.loginModel = new LoginModel();
      this.loginModel
        .save({
          url: this.$apiAllGraduatesUrl + this.loginModel.getRoute("resendOTP"),
          headers: {
            bearer: localStorage.getItem("otp_token"),
          },
        })
        .then((res) => {
          let response = res.response.data;

          console.log(response);

          if (response.message == "Expired token") {
            this.redirectToLogin();
            return;
          }

          if (!response.token) {
            this.errorMessage = "Unable to send OTP.";
            return;
          }

          this.errorMessage = null;
          this.successMessage = "OTP sent successfully";
          localStorage.setItem("otp_token", response.token);
          this.runTimer();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
          this.errorMessage = "Internal error";
          debugger;
        });
    },
    createErrorLog(error) {
      this.loginModel = new LoginModel();
      this.loginModel
        .save({
          url:
            this.$interpretersApiUrl +
            this.loginModel.getRoute("createErrorLog"),
          data: {
            message: error.message,
            file: error.file,
            process: error.process,
            project: error.project,
          },
          headers: {
            bearer: localStorage.getItem("otp_token"),
          },
        })
        .then((res) => {
          console.log("error log response");
          console.log(res);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
